const date = new Date()
const firstDay = Date.parse(new Date(date.getFullYear(), date.getMonth(), 1))

const lastDayDefault = new Date(date.getFullYear(), date.getMonth() + 1, 0)
const lastDay = Date.parse(new Date(lastDayDefault.setHours(23)))

const getNumberOfWeek = (localDate) => {
    const DAY_MS = 86400000
    const WEEK = 7
    const firstDayOfYear = new Date(localDate.getFullYear(), 0, 1)

    return Math.ceil((localDate - firstDayOfYear) / DAY_MS / WEEK) + 1
}

export {
    date,
    firstDay,
    lastDay,
    getNumberOfWeek,
}
